import { AppLayout } from 'app/layouts/app-layout';
import { AuthLayout } from 'app/layouts/auth-layout';
import { DashboardLayout } from 'app/layouts/dashboard-layout';
import { Application } from 'pages/application';
import { AgentRegister, Login, NewPass, Otp, RestorePass } from 'pages/auth';
import {
  AllApplications,
  LatestApplications,
  NewApplication,
  OpenApplication,
  OpenOffer,
  UserProfile,
} from 'pages/dashboard';
import { DraftApplicationsPage } from 'pages/dashboard/draft-applications';
import { DraftView } from 'pages/dashboard/draft-view';
import { Referals } from 'pages/dashboard/referals';
import {
  LatestAppAdmin,
  AllAppAdmin,
  OpenAppAdmin,
  OfferAdmin,
  AgentsAdmin,
  AgentAdmin,
  LeadsAdmin,
  LeadsView,
} from 'pages/dashboard-admin';
import { CatalogAdmin } from 'pages/dashboard-admin/catalog-admin';
import { CatalogItemAdmin } from 'pages/dashboard-admin/catalog-item-admin';
import { ImportExcelPage } from 'pages/dashboard-admin/import-excel';
import { LandingMain } from 'pages/landing-main';
import { LandingProduct } from 'pages/landing-product';
import { NotFound } from 'pages/not-found';
import { Offer } from 'pages/offer';
import { Referal } from 'pages/referal';
import { createBrowserRouter } from 'react-router-dom';
import { ROUTE_PATHS } from 'shared/model/constants/paths';

export const router = createBrowserRouter([
  {
    path: ROUTE_PATHS.MAIN,
    element: <AppLayout />,
    errorElement: <NotFound />,
    children: [
      {
        path: ROUTE_PATHS.MAIN,
        element: <LandingMain />,
      },
      {
        path: ROUTE_PATHS.PRODUCT,
        element: <LandingProduct />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.AUTH,
    element: <AuthLayout />,
    errorElement: <NotFound />,
    children: [
      {
        path: ROUTE_PATHS.AUTH,
        element: <Login />,
      },
      {
        path: ROUTE_PATHS.RESTORE_PASS,
        element: <RestorePass />,
      },
      {
        path: ROUTE_PATHS.OTP,
        element: <Otp />,
      },
      {
        path: ROUTE_PATHS.NEW_PASS,
        element: <NewPass />,
      },
      {
        path: ROUTE_PATHS.REGISTER_AGENT,
        element: <AgentRegister />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.APPLICATION,
    element: <DashboardLayout />,
    errorElement: <NotFound />,
    children: [
      {
        path: ROUTE_PATHS.FULL_APP,
        element: <Application />,
      },
      {
        path: ROUTE_PATHS.FULL_OFFER,
        element: <Offer />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.DASHBOARD,
    element: <DashboardLayout />,
    errorElement: <NotFound />,
    children: [
      {
        path: ROUTE_PATHS.ALL_APP,
        element: <AllApplications />,
      },
      {
        path: ROUTE_PATHS.LAST_APP,
        element: <LatestApplications />,
      },
      {
        path: ROUTE_PATHS.NEW_APP,
        element: <NewApplication />,
      },
      {
        path: ROUTE_PATHS.OPEN_APP,
        element: <OpenApplication />,
      },
      {
        path: ROUTE_PATHS.OPEN_OFFER,
        element: <OpenOffer />,
      },
      {
        path: ROUTE_PATHS.ADMIN_LAST,
        element: <LatestAppAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_ALL,
        element: <AllAppAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_APP,
        element: <OpenAppAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_OFFER,
        element: <OfferAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_AGENTS,
        element: <AgentsAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_AGENT,
        element: <AgentAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_CATALOG,
        element: <CatalogAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_CATALOG_ITEM,
        element: <CatalogItemAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_IMPORT_EXCEL,
        element: <ImportExcelPage />,
      },
      {
        path: ROUTE_PATHS.ADMIN_LEADS,
        element: <LeadsAdmin />,
      },
      {
        path: ROUTE_PATHS.ADMIN_LEAD_VIEW,
        element: <LeadsView />,
      },
      {
        path: ROUTE_PATHS.DRAFTS,
        element: <DraftApplicationsPage />,
      },
      {
        path: ROUTE_PATHS.ADMIN_DRAFTS,
        element: <DraftApplicationsPage />,
      },
      {
        path: ROUTE_PATHS.REFERALS,
        element: <Referals />,
      },
      {
        path: ROUTE_PATHS.ADMIN_REFERALS,
        element: <Referals />,
      },
      {
        path: ROUTE_PATHS.DRAFT_VIEW,
        element: <DraftView />,
      },
      {
        path: ROUTE_PATHS.ADMIN_DRAFT_VIEW,
        element: <DraftView />,
      },
      {
        path: ROUTE_PATHS.USER_PROFILE,
        element: <UserProfile />,
      },
      {
        path: ROUTE_PATHS.ADMIN_PROFILE,
        element: <UserProfile />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.REFERAL,
    element: <Referal />,
    errorElement: <NotFound />,
  },
]);
